import React, { ReactNode } from 'react';
import { TextArea } from 'blueprint-form';
import Button from '../../molecules/button';
import { produce } from 'immer';
import Callout from '../callout';

/**
 * Note: This component intended to be
 * used inside a blueprint form
 */

interface MultiTextAreaProps {
  formProps: any;
  texts: string[];
  customDataValue?: string;
  customTitle?: string;
  customCallout?: string | ReactNode;
}

const MultiTextArea = ({
  formProps,
  texts,
  customDataValue,
  customTitle,
  customCallout
}: MultiTextAreaProps) => {
  const dataValue = customDataValue || 'texts';
  const title = customTitle || 'Custom Text Messages';
  const callout: string | ReactNode = customCallout;

  const addTextArea = (): void => {
    formProps.setFieldValue(dataValue, texts.concat(''));
  };

  const removeTextArea = (index: number): void => {
    const updated = produce(texts, (draft) => {
      draft.splice(index, 1);
    });
    formProps.setFieldValue(dataValue, updated);
  };

  const clear = (): void => {
    formProps.setFieldValue(dataValue, ['']);
  };

  return (
    <React.Fragment>
      <h4 className="mt-0">{title}</h4>
      {callout && <Callout className="mb-7">{callout}</Callout>}
      {texts.length > 0 &&
        texts.map((_text: string, index: number) => (
          <div key={index}>
            <TextArea name={`${dataValue}[${index}]`} fill />
            {texts.length < 4 && index === texts.length - 1 && (
              <Button
                intent="primary"
                style={{ marginTop: '-5px' }}
                className="mb-7 mr-3"
                onClick={addTextArea}
                size="small"
              >
                Add Message
              </Button>
            )}
            {texts.length > 1 && (
              <Button
                style={{ marginTop: '-5px' }}
                className="mb-7 mr-3"
                onClick={() => removeTextArea(index)}
                size="small"
              >
                Remove Message
              </Button>
            )}
            {texts.length > 1 &&
              texts.length <= 4 &&
              index === texts.length - 1 && (
                <Button
                  style={{ marginTop: '-5px' }}
                  className="mb-7"
                  onClick={clear}
                  size="small"
                  intent="danger"
                >
                  Clear Messages
                </Button>
              )}
          </div>
        ))}
    </React.Fragment>
  );
};

export default MultiTextArea;
